import home from '../../../../assets/images/home.png';
import Search from '../../../../components/Search';
import * as styles from './styles';
// import Text from '../../../../assets/styles/Text'

export default function Banner() {
  return (
    <styles.Container>
      <h1>
        Encontre
        <br />
        Acompanhantes
        <br />
        perto de você
      </h1>

      <Search />

      <styles.ImgBackground src={home} alt="isotipo" />
    </styles.Container>
  );
}
